import type { StaticImageData } from "next/image"

export function isCloudinaryImage(image?: string | StaticImageData | null) {
  if (!image || typeof image !== "string") return false
  return /https:\/\/res\.cloudinary\.com\/.+\/image\/upload\/.+/.test(image)
}

export function getCloudinaryUrl({
  src,
  width,
  height,
  quality,
  format,
}: {
  src: string
  width: number
  height?: number
  quality?: number
  format?: string
}) {
  if (!isCloudinaryImage(src)) return src

  const [baseUrl, imagePath] = src.split(/(?<=\/upload\/)/)

  const options: string[] = []
  options.push("c_limit")
  options.push(`w_${width}`)

  if (height) options.push(`h_${height}`)

  const f = `f_${format || "auto"}`
  const q = `q_${quality || "auto"}`

  const newUrl = `${baseUrl}${options.join(",")}/${f}/${q}/${imagePath}`

  return newUrl
}
